type ToastVariant = 'success' | 'error' | 'warning' | 'info';

export class ToastService {
  private static container: HTMLElement | null = null;

  private static ensureContainer(): HTMLElement {
    if (this.container && document.body.contains(this.container)) return this.container;
    const c = document.createElement('div');
    c.id = 'nexxus-toasts';
    c.style.cssText =
      'position:fixed;top:16px;right:16px;z-index:10000;display:flex;flex-direction:column;gap:8px;';
    document.body.appendChild(c);
    this.container = c;
    return c;
  }

  static show(message: string, variant: ToastVariant = 'info', duration = 4000): void {
    const colors: Record<ToastVariant, { bg: string; border: string }> = {
      success: { bg: '#d4edda', border: '#1e7e34' },
      error: { bg: '#f8d7da', border: '#c82333' },
      warning: { bg: '#fff3cd', border: '#d39e00' },
      info: { bg: '#d1ecf1', border: '#117a8b' },
    };
    const c = colors[variant];
    const div = document.createElement('div');
    div.style.cssText = `background:${c.bg};border-left:4px solid ${c.border};padding:12px 16px;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,0.12);font-size:0.9rem;min-width:240px;max-width:400px;`;
    div.textContent = message;
    div.setAttribute('role', 'alert');
    this.ensureContainer().appendChild(div);
    setTimeout(() => {
      div.style.transition = 'opacity 0.3s';
      div.style.opacity = '0';
      setTimeout(() => div.remove(), 300);
    }, duration);
  }

  static success(msg: string): void {
    this.show(msg, 'success');
  }
  static error(msg: string): void {
    this.clear();
    this.show(msg, 'error', 8000);
  }

  /** Retire les toasts visibles (avant un nouveau message d’erreur). */
  static clear(): void {
    const c = this.container ?? document.getElementById('nexxus-toasts');
    if (!c) return;
    c.querySelectorAll(':scope > div').forEach((el) => el.remove());
  }

  static warning(msg: string): void {
    this.show(msg, 'warning');
  }
  static info(msg: string): void {
    this.show(msg, 'info');
  }
}
